import {HttpInterceptorFn, provideHttpClient, withInterceptors} from '@angular/common/http';
import {ApplicationConfig, inject, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {isPlatformServer} from '@angular/common';

export function prefixInterceptorFactory(apiPrefix: string): HttpInterceptorFn {
  return (req, next) => {
    const platformId = inject(PLATFORM_ID);

    if (!/^https?:\/\//i.test(req.url)) {
      req = req.clone({url: `${apiPrefix}/${req.url}`});
    }
    return next(req);
  };
}

